exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert-danger {\n  margin-top: 2em;\n}\n.alert-danger /deep/ td {\n  padding-left: 10px;\n}\n.alert-danger /deep/ td:first-child {\n  padding-left: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/errors/errors.component.less
// module id = ../../../../../src/app/shared/errors/errors.component.less
// module chunks = 2